import React, { useRef, useEffect } from "react";
import { Row, Col, Button, Form } from "antd";
import { useDispatch } from "react-redux";
import moment from "moment";
import DatePicker from "react-date-picker/dist/entry.nostyle";
import {
  CustomLabel,
  BookAppointmentButton,
} from "../../../../../../Common/style";
import { maskPhoneNumber, maskedEmail, convertTo24Hour,  scrollToTop, getAllowedMaxTimeByMedicalSet } from "../../../../../../Utils";
import { useIsMobile } from "../../../../../../Hooks";
import CONSTANTS from "../../../../../../Utils/constant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import AppointmentModal from "../../../AppointmentModal";
import {
  callIcon,
  markerIcon,
  calenderBlueIcon,
} from "../../../../../../Assets/Images";
import { PolicyDetails } from "../../../../CommonData";
import PAGE_CONSTANTS from "../../../constant";
import { getGender, getAdditionalSetList } from "../../../../../../Utils";
import { BookVisitDetails, AppointmentDetails } from "../../../../CommonData";
import { validateHomePincode, validateAddressLine1, pickerOptionsMinutes, pickerOptionsHours, validateLandmark, validateAddressLine2, validateCity, getMaxDate, getMinDate } from "../../handlers";
import { setAddress, setAppointmentDate, setErrors, setAppointmentTime, setEmail, setMobile, setCity, setIsModalOpen, setHomePincode } from "../../../../../../Redux/BookMedicalVisit/action";
import "./houseVisitBooking.css";

const HouseVisitBookingTemplate = ({
  selectedMember,
  tpaDetails,
  bookAppointment
}) => {
  const {
    applicationID,
    policyType,
    businessType,
    inwardTypeCode,
    proposerCity,
    proposerFirstName,
    proposerInitial,
    proposerLastName,
    proposerPincode,
    proposerState,
    proposerArea,
    proposerAddress,
    proposalDetails,
    policyNum,
    appSource
  } = PolicyDetails();
  const { AppointmentBookings } = AppointmentDetails()
  const isMobile = useIsMobile();
  const dispatch = useDispatch();
  const isDisablePM = getAllowedMaxTimeByMedicalSet(selectedMember?.MedicalTestSet) === PAGE_CONSTANTS?.ALLOWED_TIMING_ELEVEN_AM;
  const { [selectedMember?.MemberId]: bookState } = BookVisitDetails();
  const {
    selectedCenter,
    includedMembers,
    pinCode,
    appointmentDate,
    mobile,
    email,
    address,
    city,
    homePincode,
    appointmentTime,
    isModalOpen,
    errors
  } = bookState || {}

  const handleError = (error) => {
    dispatch(setErrors({ memberId: selectedMember?.MemberId, value: error}))
  }
  const getSelectedCenterAddress = () => {
    return `${selectedCenter?.address}, ${selectedCenter?.pinCode}`;
  };
  const getAddress = () => {
    return `${address?.line1}${address?.line2 ? ', ' + address?.line2: ''}${address?.landmark ? ', ' + address?.landmark : ''}${city ? ', ' + city : ''} ${homePincode}`;
  };
  const toggleModal = () => {
    dispatch(setIsModalOpen({ memberId: selectedMember?.MemberId, value:!isModalOpen}));
  };

  const getInsuredMemberObj = (memberDetails) => {
    const isMedicalSetAvailable =  memberDetails?.MedicalTestSetName && memberDetails?.MedicalTestSet;
    const isIncludedMember = includedMembers?.includes(memberDetails?.MemberId);
    return {
      Member_id: memberDetails?.MemberId,
      insured_id: memberDetails?.CustomerId || "",
      insured_initial: memberDetails?.InsuredInitial,
      insured_First_name: memberDetails?.FirstName,
      insured_Middle_name: memberDetails?.MiddleName,
      insured_Last_name: memberDetails?.LastName,
      insured_mobile_number: mobile,
      insured_residence_number: "",
      insured_office_number: "",
      insured_emailid: email,
      insured_pincode: pinCode,
      insured_state: memberDetails?.InsuredState,
      insured_landmark: isIncludedMember ? address?.landmark : "",
      insured_city: memberDetails?.InsuredCity,
      insured_address1: "",
      insured_address2: "",
      insured_address3: null,
      insured_dob: memberDetails?.InsuredDob ? moment(memberDetails?.InsuredDob,CONSTANTS?.FORMAT_DOB).format(CONSTANTS?.FORMAT_DOB_SLASH) : "",
      insured_age: memberDetails?.InsuredAge,
      insured_gender: getGender(memberDetails?.InsuredGender),
      Priority_hniflag: false,
      Appointment_type: "PPMC",
      CallMe_Now_flag: false,
      Appointment_preferred_date1: isIncludedMember ? moment(
        appointmentDate,
        CONSTANTS?.FORMAT_DOB
      ).format(CONSTANTS?.FORMAT_DOB_SLASH) : "",
      Appointment_preferred_time1: isIncludedMember ? convertTo24Hour(
        appointmentTime?.hour,
        appointmentTime?.minute,
        appointmentTime?.meridiem
      ) : "",
      Appointment_preferred_date2: "",
      Appointment_preferred_time2: "00:00:00",
      Appointment_preferred_date3: "",
      Appointment_preferred_time3: "00:00:00",
      Preferred_Gender: "M",
      PPMC_Test_Decription: memberDetails?.MedicalTestSetName,
      PPMC_test_set: memberDetails?.MedicalTestSet,
      tpa_code: tpaDetails?.tpa,
      tpa_identifier: isIncludedMember ? `${tpaDetails?.tpa}-${PAGE_CONSTANTS?.HOME_VISIT_TYPE}` : `${tpaDetails?.tpa}-${PAGE_CONSTANTS?.DIAGNOSTIC_CENTER_TYPE}`,
      visit_type: isIncludedMember ? PAGE_CONSTANTS?.HOME_VISIT_TYPE : PAGE_CONSTANTS?.DIAGNOSTIC_CENTER_TYPE,
      home_address1: isIncludedMember ? address?.line1 : "",
      home_address2: isIncludedMember ? address?.line2 : "",
      Home_address3: isIncludedMember ? address?.landmark : "",
      Home_city: isIncludedMember ? city : "",
      Home_state: "",
      Home_pincode: isIncludedMember ? homePincode : "",
      Preferred_DC_state: null,
      preferred_city: null,
      preferred_dc_name: isIncludedMember ? selectedCenter?.name : "",
      preferred_dc_code: isIncludedMember ? selectedCenter?.dcCode : "",
      dcAddress: null,
      Additional_test: !isMedicalSetAvailable ? memberDetails?.MedicalTest : null,
      Repeattest: "False",
      additional_field1: null,
      additional_field2: null,
      additional_field3: null,
      additional_field4: null,
      additional_field5: null,
      additional_field6: null,
      additional_field7: null,
      additional_field8: null,
      additional_field9: null,
      additional_field10: null,
      Additional_test_Set: !isMedicalSetAvailable ? getAdditionalSetList(memberDetails?.MedicalTest) : null,
    };
  };
  const getInsuredMemberInfo = () => {
    const AlreadyBookedIdList = AppointmentBookings?.filter((item) => item?.Appointment_preferred_time1)?.map((booking) => booking?.Member_id);
    const filteredInsuredMember = proposalDetails?.MemberDetails?.filter(
      (memberItem) =>
        ((memberItem?.MedicalTestSet && memberItem?.MedicalTestSetName) ||
          memberItem?.MedicalTest) &&
        !AlreadyBookedIdList?.includes(memberItem?.MemberId)
    )
    const insuredMembersList = filteredInsuredMember?.map((memberDetails) => getInsuredMemberObj(memberDetails));
    return insuredMembersList;
  };
  const handleAppointmentBooking = () => {
    const requestPayload = {
      Application_Number: applicationID,
      policy_type: policyType,
      Business_Type: businessType || "Urban",
      Inward_Type: inwardTypeCode,
      Proposer_initial: proposerInitial,
      Proposer_Name: `${proposerFirstName} ${proposerLastName}`,
      Proposer_Mobile_number: proposalDetails?.ProposerMobile,
      Proposer_EmailId: proposalDetails?.ProposerEmail,
      Proposer_City: proposerCity,
      Proposer_State: proposerState,
      Proposer_pincode: proposerPincode,
      Proposer_Area: proposerArea,
      Lead_Id: null,
      policy_no: policyNum,
      source: appSource,
      Insured_Info: getInsuredMemberInfo(),
      HNIFlag: "NO",
    };
    if(getInsuredMemberInfo()?.length){
      bookAppointment(requestPayload, tpaDetails?.tpa);
      toggleModal();
    }
  };
  const onAddressChange = (type, value) => {
    switch (type) {
      case "LINE1":
        dispatch(
          setAddress({
            memberId: selectedMember?.MemberId,
            value: {
              ...address,
              line1: value,
            },
          })
        );
        break;
      case "LINE2":
        dispatch(
          setAddress({
            memberId: selectedMember?.MemberId,
            value: {
              ...address,
              line2: value,
            },
          })
        );
        break;
      case "LANDMARK":
        dispatch(
          setAddress({
            memberId: selectedMember?.MemberId,
            value: {
              ...address,
              landmark: value,
            },
          })
        );
        break;
      default:
        break;
    }
  };
  const onCityChange = (e) => {
    dispatch(setCity({memberId: selectedMember?.MemberId, value: e?.target?.value}));
  };
  const onHomePincodeChange = (e) => {
    dispatch(setHomePincode({memberId: selectedMember?.MemberId, value: e?.target?.value}));
  };
  const onTimeChange = (type, value) => {
    switch (type) {
      case "HOUR":
        const isResetMinute = ((value === "05" &&
          appointmentTime?.meridiem === PAGE_CONSTANTS?.MERIDIEM_PM) || (value === "11" &&
            appointmentTime?.meridiem === PAGE_CONSTANTS?.MERIDIEM_AM));
        dispatch(
          setAppointmentTime({
            memberId: selectedMember?.MemberId,
            value: {
              ...appointmentTime,
              ...(isResetMinute && {minute: `00`}),
              hour: value,
            },
          })
        );
        break;
      case "MINUTE":
        dispatch(
          setAppointmentTime({
            memberId: selectedMember?.MemberId,
            value: {
              ...appointmentTime,
              minute: value,
            },
          })
        );
      break;
      case "MERIDIEM":
        dispatch(
          setAppointmentTime({
            memberId: selectedMember?.MemberId,
            value: {
              hour: pickerOptionsHours(value)?.[0],
              minute: `00`,
              meridiem: value,
            },
          })
        );
        break;
      default:
        break;
    }
  };
  const onDateChange = (e) => {
    dispatch(setAppointmentDate({memberId: selectedMember?.MemberId, value: moment(e).format(CONSTANTS.FORMAT_DOB)}));
  };
  const datepickerRefApt = useRef(null);
  function handleClickDatepickerIcon(datePicker) {
    const datepickerElement = datePicker.current;
    datepickerElement.toggleCalendar();
  }

  const onFinish = (values) => {
    toggleModal();
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  useEffect(() => {
    if(!appointmentDate){
      dispatch(setAppointmentDate({memberId: selectedMember?.MemberId, value: moment(getMinDate(true)).format(CONSTANTS.FORMAT_DOB)}));
    }
    if(!homePincode){
      dispatch(setHomePincode({memberId: selectedMember?.MemberId, value: pinCode}));
    }
    scrollToTop(100);
  }, []);

  useEffect(() => {
    if(proposalDetails?.ProposerEmail && !email){
      dispatch(setEmail({memberId: selectedMember?.MemberId, value: proposalDetails?.ProposerEmail}));
    }
    if(proposalDetails?.ProposerMobile && !mobile){
      dispatch(setMobile({memberId: selectedMember?.MemberId, value: proposalDetails?.ProposerMobile}));
    }
    if(proposerAddress && !address?.line1 && !address?.line2){
      dispatch(setAddress({memberId: selectedMember?.MemberId, value: {
        ...address,
        line1: proposerAddress?.addressLine1Lang1,
        line2: proposerAddress?.addressLine2Lang1,
      },}));
    }
  },[proposalDetails, proposerAddress])

  return (
    <>
      <div className="dc-selected-block">
        <CustomLabel font_size="14" font_weight="normal" className="mb-4">
          {"Note : Representative will visit from the below diagnostic center."}
        </CustomLabel>
        <Row>
          <CustomLabel font_size="16" font_weight="bold">
            {selectedCenter?.name}
          </CustomLabel>
        </Row>
        <Row gutter={[12, 10]}>
          <Col md={20} lg={13} style={{ marginTop: "16px" }}>
            <Row>
              <Col xs={2}>
                <img src={markerIcon} alt={"marker"} />
              </Col>
              <Col xs={16} sm={18} md={22}>
                <CustomLabel font_size="14" font_weight="normal">
                  {getSelectedCenterAddress()}
                </CustomLabel>
              </Col>
            </Row>
            {selectedCenter?.contactNo && <Row>
              <Col xs={2} style={{ marginTop: "12px" }}>
                <img src={callIcon} alt={"call"} />
              </Col>
              <Col xs={16} sm={18} md={12} style={{ marginTop: "12px" }}>
                <CustomLabel font_size="14" font_weight="normal">
                  {selectedCenter?.contactNo}
                </CustomLabel>
              </Col>
            </Row>}
          </Col>
        </Row>
      </div>
      {isMobile && <div className="dc-selected-divider" />}
      <CustomLabel
        font_size="18"
        font_weight="bold"
        style={{ marginTop: "38px", marginBottom: "10px" }}
      >
        {"3. Enter Below Details"}
      </CustomLabel>
      <Form
        name="bookVisit"
        autoComplete="off"
        className="house-visit-book"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Row gutter={[10, 5]}>
            <Col md={8}>
              <legend className="bold input_heading font_14">
                {"Address Line 1 "}
                <span style={{ color: "red" }}>*</span>
              </legend>
              <Form.Item
                name="addressLine1"
                validateStatus={!!errors?.addressLine1 ? "error" : "success"}
                help={errors?.addressLine1}
                rules={[
                  {
                    validator: validateAddressLine1(
                      address?.line1,
                      handleError
                    ),
                  },
                ]}
              >
                <div className="input_wrap">
                  <input
                    type="text"
                    placeholder="Line 1"
                    className="input_form"
                    name="addressLine1"
                    value={address?.line1 || ""}
                    maxLength="50"
                    onChange={(e) => onAddressChange("LINE1", e?.target?.value)}
                    autoComplete="off"
                  />
                  <span className="info_icon">
                    <i className="fa fa-map-marker" aria-hidden="true"></i>
                  </span>
                </div>
              </Form.Item>
            </Col>
            <Col md={8}>
              <legend className="bold input_heading font_14">
                {"Address Line 2"}
              </legend>
              <Form.Item
                name="addressLine2"
                validateStatus={!!errors?.addressLine2 ? "error" : "success"}
                help={errors?.addressLine2}
                rules={[
                  {
                    validator: validateAddressLine2(
                      address?.line2,
                      handleError
                    ),
                  },
                ]}
              >
              <div className="input_wrap">
                <input
                  type="text"
                  placeholder="Line 2"
                  className="input_form"
                  name="addressLine2"
                  maxLength="50"
                  value={address?.line2 || ""}
                  onChange={(e) => onAddressChange("LINE2", e?.target?.value)}
                  autoComplete="off"
                />
                <span className="info_icon">
                  <i className="fa fa-map-marker" aria-hidden="true"></i>
                </span>
              </div>
              </Form.Item>
            </Col>
            <Col md={8}>
              <legend className="bold input_heading font_14">
                {"Landmark"}
              </legend>
              <Form.Item
                name="landmark"
                validateStatus={!!errors?.landmark ? "error" : "success"}
                help={errors?.landmark}
                rules={[
                  {
                    validator: validateLandmark(
                      address?.landmark,
                      handleError
                    ),
                  },
                ]}
              >
              <div className="input_wrap pl-3">
                <input
                  type="text"
                  placeholder="Landmark"
                  className="input_form "
                  name="landmark"
                  value={address?.landmark || ""}
                  onChange={(e) =>
                    onAddressChange("LANDMARK", e?.target?.value)
                  }
                  maxLength="50"
                  autoComplete="off"
                />
              </div>
              </Form.Item>
            </Col>
            <Col md={8}>
              <legend className="bold input_heading font_14">
                {"City "}
                <span style={{ color: "red" }}>*</span>
              </legend>
              <Form.Item
                name="city"
                validateStatus={!!errors?.city ? "error" : "success"}
                help={errors?.city}
                rules={[
                  {
                    validator: validateCity(
                      city,
                      handleError
                    ),
                  },
                ]}
              >
                <div className="input_wrap pl-3">
                  <input
                    type="text"
                    placeholder="City"
                    className="input_form"
                    name="addressLine1"
                    value={city || ""}
                    maxLength="50"
                    onChange={onCityChange}
                    autoComplete="off"
                  />
                </div>
              </Form.Item>
            </Col>
            <Col md={8}>
              <legend className="bold input_heading font_14">
                {"Pincode "}
                <span style={{ color: "red" }}>*</span>
              </legend>
              <Form.Item
                name="homePincode"
                validateStatus={!!errors?.homePincode ? "error" : "success"}
                help={errors?.homePincode}
                rules={[
                  {
                    validator: validateHomePincode(
                      homePincode,
                      handleError
                    ),
                  },
                ]}
              >
                <div className="input_wrap pl-3">
                  <input
                    type="text"
                    placeholder="Pincode"
                    className="input_form"
                    name="homePincode"
                    value={homePincode || ""}
                    maxLength="6"
                    onChange={onHomePincodeChange}
                    autoComplete="off"
                  />
                </div>
              </Form.Item>
            </Col>
          </Row>
        </div>
        <CustomLabel
          font_size="18"
          font_weight="bold"
          style={{ marginTop: "10px", marginBottom: "10px" }}
        >
          {"4. Select Preferred Date"}
        </CustomLabel>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "24px",
          }}
        >
          <div className="input pl-2 pr-2 date_open">
            <DatePicker
              ref={datepickerRefApt}
              calendarType={"US"}
              id={"appointmentDate"}
              onChange={onDateChange}
              value={
                appointmentDate
                  ? moment(appointmentDate, CONSTANTS?.FORMAT_DOB).toDate()
                  : ""
              }
              clearIcon={null}
              minDate={getMinDate()}
              maxDate={getMaxDate()}
              defaultView="month"
              calendarIcon={null}
              format="dd/MM/yyyy"
              dayPlaceholder="DD"
              monthPlaceholder="MM"
              yearPlaceholder="YYYY"
            />
          </div>
          <span className="open_picker" style={{ paddingLeft: "10px" }}>
            <img
              src={calenderBlueIcon}
              onClick={() => handleClickDatepickerIcon(datepickerRefApt)}
              alt="calendar"
            />
          </span>
        </div>

        <CustomLabel
          font_size="18"
          font_weight="bold"
          style={{ marginTop: "10px", marginBottom: "10px" }}
        >
          {"5. Select Preferred Time"}
        </CustomLabel>
        <div className="input_wrap time-picker-container">
          <label className="input_other">
            <select
              name="hour"
              id="hourTime"
              className="time-pick-dropdown"
              data-validation="required"
              value={appointmentTime?.hour || ""}
              onChange={(e) => onTimeChange("HOUR", e?.target?.value)}
            >
              {pickerOptionsHours(appointmentTime?.meridiem)?.map(
                (item, index) => (
                  <option key={item + index} value={item}>
                    {item}
                  </option>
                )
              )}
            </select>
          </label>
          <label className="input_other ml-1">
            <select
              name="minutes"
              id="minutesTime"
              className="time-pick-dropdown"
              value={appointmentTime?.minute || ""}
              onChange={(e) => onTimeChange("MINUTE", e?.target?.value)}
            >
              {pickerOptionsMinutes(
                (appointmentTime?.hour === "05" &&
                  appointmentTime?.meridiem === PAGE_CONSTANTS?.MERIDIEM_PM) || (appointmentTime?.hour === "11" &&
                    appointmentTime?.meridiem === PAGE_CONSTANTS?.MERIDIEM_AM)
              )}
            </select>
          </label>
          <div
            className="mt_booking_detail"
            style={{ paddingLeft: "0px", width: "unset" }}
          >
            <input
              className="titleRadio"
              id={"am"}
              value={"AM"}
              type="radio"
              checked={
                appointmentTime?.meridiem === PAGE_CONSTANTS?.MERIDIEM_AM
              }
              required
              name="nameTitle"
              data-validation="required"
            />
            <label
              onClick={() =>
                onTimeChange("MERIDIEM", PAGE_CONSTANTS?.MERIDIEM_AM)
              }
              className="cigna_button"
              style={{
                borderBottomRightRadius: 0,
                borderTopRightRadius: 0,
              }}
            >
              {"AM"}
            </label>
            <input
              className="titleRadio"
              id={"pm"}
              value={"PM"}
              checked={
                appointmentTime?.meridiem === PAGE_CONSTANTS?.MERIDIEM_PM
              }
              type="radio"
              required
              name="nameTitle"
              data-validation="required"
            />
            <label
              onClick={!isDisablePM ? () =>
                onTimeChange("MERIDIEM", PAGE_CONSTANTS?.MERIDIEM_PM)
               : null}
              className={isDisablePM ? "cigna_button meridiem-disable" : "cigna_button"}
              style={{
                borderBottomLeftRadius: 0,
                borderTopLeftRadius: 0,
              }}
            >
              {"PM"}
            </label>
          </div>
        </div>
        <Form.Item>
          <BookAppointmentButton disable={false}>
            <Button type="text" disabled={false} htmlType="submit">
              {"Book Appointment"}
              <FontAwesomeIcon
                icon={faAngleRight}
                style={{ marginLeft: "15px" }}
              />
            </Button>
          </BookAppointmentButton>
        </Form.Item>
      </Form>
      <AppointmentModal
        open={isModalOpen}
        onClose={toggleModal}
        date={appointmentDate}
        time={appointmentTime}
        mobile={maskPhoneNumber(mobile)}
        address={getAddress()}
        email={maskedEmail(email)}
        appointmentType={PAGE_CONSTANTS?.HOME_VISIT_TYPE}
        onBooking={handleAppointmentBooking}
      />
    </>
  );
};

export default HouseVisitBookingTemplate;
